
$(() => {
    $('body').on('click', '.b-simple-tabs__head-item', (e) => {
        const $tabHead = $(e.currentTarget);
        const $block = $tabHead.closest('.b-simple-tabs').eq(0);
        const $content = $block.find('> .b-simple-tabs__content');
        const $tabs = $content.find('> .b-simple-tabs__tab');
        const $caption = $block.find('.b-simple-tabs__caption');
        const $tabHeads = $tabHead.siblings().add($tabHead);
        const index = $tabHead.index();
        const caption = $tabs.eq(index).data('caption');
        
        if (caption && $caption.length > 0) {
            $caption.text(caption)
        }
        $tabs.removeClass('is-active').eq(index).addClass('is-active')
        $tabHeads.removeClass('is-active').eq(index).addClass('is-active')
    });

    $('body').on('click', '.b-simple-tabs__left-arrow, .b-simple-tabs__right-arrow', (e) => {
        const $arrow = $(e.currentTarget);
        const direction = $arrow.hasClass('b-simple-tabs__left-arrow') ? -1 : 1;
        const $block = $arrow.closest('.b-simple-tabs');
        const $content = $block.find('> .b-simple-tabs__content');
        const $tabs = $content.find('> .b-simple-tabs__tab');
        const $activeTab = $tabs.filter('.is-active');
        const $caption = $block.find('.b-simple-tabs__caption');
        const $tabHeads = $block.find('.b-simple-tabs__head-item')

        const index = $activeTab.index();
        let nextIndex = index + direction;

        if (nextIndex < 0) {
            nextIndex = $tabs.length - 1;
        }
        if (nextIndex >= $tabs.length) {
            nextIndex = 0;
        }

        const caption = $tabs.eq(nextIndex).data('caption');

        if (caption && $caption.length > 0) {
            $caption.text(caption)
        }

        $tabs.removeClass('is-active').eq(nextIndex).addClass('is-active')

        if ($tabHeads.length > 0) {
            $tabHeads.removeClass('is-active').eq(nextIndex).addClass('is-active')
        }
    });

    $('body').on('changeTab', '.b-simple-tabs', (e, index) => {
        e.stopPropagation();
        const $block = $(e.currentTarget);
        const $content = $block.find('> .b-simple-tabs__content');
        const $tabs = $content.find('> .b-simple-tabs__tab');
        const $tabHeads = $block.find('.b-simple-tabs__head-item');
        const $caption = $block.find('.b-simple-tabs__caption');

        const caption = $tabs.eq(index).data('caption');

        if (caption && $caption.length > 0) {
            $caption.text(caption)
        }

        $tabs.removeClass('is-active').eq(index).addClass('is-active')
        
        if ($tabHeads.length > 0) {
            $tabHeads.removeClass('is-active').eq(index).addClass('is-active')
        }
    })
});